import Component from 'flarum/common/Component';
import Link from 'flarum/common/components/Link';
import buildCrumbs from './buildCrumbs';
function updateRootVisibility(visible) {
  const root = document.getElementById('app-breadcrumbs');
  if (!root) {
    return;
  }
  root.classList.toggle('App-breadcrumbs--visible', visible);
  if (visible) {
    root.removeAttribute('hidden');
  } else {
    root.setAttribute('hidden', '');
  }
}
export default class BreadcrumbBar extends Component {
  oninit() {
    this.updateVisibility();
  }
  onupdate() {
    this.updateVisibility();
  }
  updateVisibility() {
    updateRootVisibility(!!buildCrumbs());
  }
  view() {
    const crumbs = buildCrumbs();
    if (!crumbs) {
      return null;
    }
    const lastIndex = crumbs.length - 1;
    return m("nav", {
      className: "BreadcrumbBar",
      "aria-label": "Drobe\u010Dkov\xE1 navigace"
    }, m("div", {
      className: "container"
    }, m("ol", {
      className: "BreadcrumbBar-list"
    }, crumbs.map((crumb, index) => {
      const isCurrent = index === lastIndex;
      return m("li", {
        className: "BreadcrumbBar-item",
        key: "".concat(crumb.label, "-").concat(index)
      }, index > 0 && m("span", {
        className: "BreadcrumbBar-separator",
        "aria-hidden": "true"
      }, "\u203A"), isCurrent || !crumb.href ? m("span", {
        className: "BreadcrumbBar-current",
        "aria-current": "page"
      }, crumb.label) : m(Link, {
        className: "BreadcrumbBar-link",
        href: crumb.href
      }, crumb.label));
    }))));
  }
}
flarum.reg.add('dia-theme', 'forum/features/breadcrumbs/BreadcrumbBar', BreadcrumbBar);